import config from '../utils/config'
import request from '../utils/request'

const {api} = config;
const {
    userStats,
    user,
    usersPurchased,
    users,
    userDefault,
    userFilldForm,
    userRegister,
    userForget,
    userEnable,
    userDisable,
    usersEnable,
    usersDisable,
    userAddress,
    userAddresses,
    userAddressDefault,
    fetchFeeRate,
    updateFeeRate,
    setSha1Id,
    useVasBuy,
    userConsumeStatistics,
    userBuyVas,
    userQcoinTrans,
    userCashTransTypes,
    userRemove,
    usersEnableToken,
    userInfo,
    userEventStatistics
} = api

/**
 * 查找当前用户
 */
export async function findUserDefault(params) {
    return request({url: userDefault, method: 'get', data: params,})
}
export async function findUserDefaultInfo(params) {
    return request({url: userInfo, method: 'get', data: params,})
}
/**
 * 查找当前用户填写的报名表单
 */
export async function findUserFilldForm(params) {
    return request({url: userFilldForm, method: 'get', data: params,})
}
/**
 * 查找当前用户购买的订阅服务
 */
export async function findUsersPurchased(params) {
    return request({url: usersPurchased, method: 'get', data: params,})
}


/**
 * 查找user概要统计
 */
export async function findUserStats(params) {
    return request({url: userStats, method: 'get', data: params,})
}


/**
 * 编辑当前用户
 */
export async function updateUserDefault(params) {
    return request({url: userDefault, method: 'put', data: params,})
}
/**
 * 编辑当前用户部分资料
 */
export async function updateUserPatchDefault(params) {
    return request({url: userDefault, method: 'patch', data: params,})
}

/**
 * 查找用户
 */
export async function findUser(params) {
    return request({url: user, method: 'get', data: params,})
}

/**
 * 查找用户购买的增值商品
 */
export async function findUserBuy(params) {
    return request({url: useVasBuy, method: 'get', data: params,})
}

/**
 * 查找用户收货地址
 */
export async function findUserAddresses(params) {
    return request({url: userAddresses, method: 'get', data: params,})
}

export async function findUserAddress(params) {
    return request({url: userAddress, method: 'get', data: params,})
}

/**
 * 创建用户
 */
export async function createUser(params) {
    return request({url: users, method: 'post', data: params,})
}

export async function registerUser(params) {
    return request({url: userRegister, method: 'post', data: params,})
}

export async function forgetUser(params) {
    return request({url: userForget, method: 'post', data: params,})
}

/**
 * 创建用户收货地址
 */
export async function createUserAddress(params) {
    return request({url: userAddresses, method: 'post', data: params,})
}

/**
 * 修改用户收货地址
 */
export async function updateUserAddress(params) {
    return request({url: userAddress, method: 'put', data: params,})
}

/**
 * 更新用户
 */
export async function updateUser(params) {
    return request({url: user, method: 'put', data: params,})
}

/**
 * 删除用户
 */
export async function deleteUser(params) {
    return request({url: user, method: 'delete', data: params,})
}


/**
 * 查找用户列表
 */
export async function findUsers(params) {
    return request({url: users, method: 'get', data: params,})
}

/**
 * 删除用户
 */
export async function deleteUsers(params) {
    return request({url: user, method: 'delete', data: params,})
}

/**
 * 删除收货地址
 */
export async function deleteUserAddress(params) {
    return request({url: userAddress, method: 'delete', data: params,})
}


/**
 * 解除冻结用户
 */
export async function enableUser(params) {
    return request({url: userEnable, method: 'post', data: params,})
}


/**
 * 冻结用户
 */
export async function disableUser(params) {
    return request({url: userDisable, method: 'post', data: params,})
}


/**
 * 解除冻结用户
 */
export async function enableUsers(params) {
    return request({url: usersEnable, method: 'post', data: params,})
}


/**
 * 冻结用户
 */
export async function disableUsers(params) {
    return request({url: usersDisable, method: 'post', data: params,})
}

/**
 * 设置收货地址为默认
 */
export async function letUserAddressIsDefault(params) {
    return request({url: userAddressDefault, method: 'post', data: params,})
}

/**
 * 查询用户提现费率
 */
export async function userRateFetch(params) {
    return request({url: fetchFeeRate, method: 'get', data: params,})
}

/**
 * 修改用户费率
 */
export async function userRateUpdate(params) {
    return request({url: updateFeeRate + '?rate='+params.rate, method: 'put', data: params,})
}
/**
 * 加密
 */
export async function setUserSha1Id(params) {
    return request({url: setSha1Id, method: 'put', data: params,})
}

/**
 * 加密
 */
export async function statisticsUserConsume(params) {
    return request({url: userConsumeStatistics + `?startTime=${params.startTime}&endTime=${params.endTime}`, method: 'get'})
}

/**
 * 查找
 */
export async function findUserBuyVas(params) {
    return request({url: userBuyVas, method: 'get', data: params,})
}
export async function findUserQcoinTrans(params) {
    return request({url: userQcoinTrans, method: 'get', data: params,})
}
export async function findUserCashTransTypes(params) {
    return request({url: userCashTransTypes, method: 'get', data: params,})
}

/*注销*/
export async function removeUser(params) {
    return request({url: userRemove, method: 'post', data: params,})
}
/*token是否有效*/
export async function findUsersEnableToken(params) {
    return request({url: usersEnableToken, method: 'get', data: params,})
}
/*统计*/
export async function findUsersEventStatistics(params) {
    return request({url: userEventStatistics, method: 'get', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/user.js